import { useEffect } from 'react';
import styles from './Table.module.scss';
import { usePagination } from 'app/helpers/usePagination';

import clsx from 'clsx';
import { Icon } from 'app/components';

interface Props {
  pageChangeHandler: any;
  currentPage: number;
  totalCount: number;
  rowsPerPage: number;
}

export const Pagination = ({ currentPage, pageChangeHandler, totalCount, rowsPerPage }: Props) => {
  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount: 1,
    pageSize: rowsPerPage,
  });

  useEffect(() => {
    pageChangeHandler(currentPage);
  }, [currentPage]);

  if (paginationRange && (currentPage === 0 || paginationRange.length < 2)) {
    return null;
  }

  const lastPage = paginationRange && paginationRange[paginationRange.length - 1];

  const onNext = () => {
    pageChangeHandler(currentPage + 1);
  };
  const onFirst = () => {
    pageChangeHandler(1);
  };
  const onLast = () => {
    pageChangeHandler(lastPage);
  };

  const onPrevious = () => {
    pageChangeHandler(currentPage - 1);
  };

  return (
    <ul className={clsx(styles.pagination_container)}>
      <li className={clsx(styles.pagination_item, currentPage === 1 && styles.disabled)} onClick={onFirst}>
        <Icon name="pagination-first-page" size="12" />
      </li>
      <li className={clsx(styles.pagination_item, currentPage === 1 && styles.disabled)} onClick={onPrevious}>
        <Icon name='pagination-arrow-left' size="12" />
      </li>
      {paginationRange?.map((pageNumber, i) => {
        if (pageNumber === 'DOTS') {
          return (
            <li key={i} className={styles.pagination_dots}>
              &#8230;
            </li>
          );
        }

        return (
          <li
            key={i}
            className={clsx(styles.pagination_item, pageNumber === currentPage && styles.selected)}
            onClick={() => pageChangeHandler(pageNumber)}
          >
            {pageNumber}
          </li>
        );
      })}

      <li className={clsx(styles.pagination_item, currentPage === lastPage && styles.disabled)} onClick={onNext}>
        <Icon name='pagination-arrow-right' size="12" />
      </li>

      <li className={clsx(styles.pagination_item, currentPage === lastPage && styles.disabled)} onClick={onLast}>
        <Icon name="pagination-last-page" size="12" />
      </li>
    </ul>
  );
};
